import * as React from 'react';
import { ReactElement } from 'react';
import { createStyles, Grid, makeStyles, TextField } from '@material-ui/core';
import { UserStatus } from 'types/member';
import { CheckObjectValue } from 'types/common';
import { userStatusOption } from 'constants/member/connect';
import MultipleCheckboxFilter from 'components/common/searchfilter/MultipleCheckboxFilter';
import FilterElementLayout from 'components/common/searchfilter/FilterElementLayout';
import MemberSeachFilterLayout from 'components/member/memberSearchFilterLayout';

interface Props {
  keyword: string;
  userStatus: CheckObjectValue;
  onChangeKeyword: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDownKeyword: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onChangeUserStatus: (values: UserStatus[]) => void;
  onClickSearch: () => void;
  onClickReset: () => void;
}

const SearchFilter = ({
  keyword,
  userStatus,
  onChangeKeyword,
  onKeyDownKeyword,
  onChangeUserStatus,
  onClickSearch,
  onClickReset,
}: Props): ReactElement => {
  const userStatusCheckboxes = Object.entries(userStatus)
    .filter(([_userStatus, isChecked]) => isChecked)
    .map(([userStatus, _isChecked]) => Number(userStatus));

  const classes = makeStyles(() =>
    createStyles({
      root: {
        width: '30%',
      },
    }),
  )();

  return (
    <MemberSeachFilterLayout getSearchResult={onClickSearch} resetFilter={onClickReset}>
      <Grid>
        <Grid item xs={12}>
          <FilterElementLayout label={'Keyword'} gridSize={1}>
            <TextField
              classes={classes}
              placeholder="Email, External, Group ID, Domain"
              value={keyword}
              onChange={onChangeKeyword}
              onKeyDown={onKeyDownKeyword}
            />
          </FilterElementLayout>
        </Grid>
      </Grid>

      <Grid>
        <Grid item xs={12}>
          <MultipleCheckboxFilter<UserStatus>
            statuses={userStatusCheckboxes}
            onChangeChecked={onChangeUserStatus}
            filterLabel={'User Status'}
            checkedOptions={userStatusOption}
            gridSize={1}
          />
        </Grid>
      </Grid>
    </MemberSeachFilterLayout>
  );
};

export default SearchFilter;
